export default __webpack_public_path__ + "static/media/profilePic.0e6b5db9.jpg";